import React from 'react';

import { Row } from '../../../models/app-data-model';
import './table-row.scss';

export type TableRowProps = {
  row?: Row[];
};

const TableRow: React.FC<TableRowProps> = ({ row }: TableRowProps) => {
  const highlightRow = row && row.filter((item) => item.highlight_row)?.length > 0;
  return (
    <tr className={`table-row ${highlightRow ? 'highlight-row' : ''}`}>
      {row?.map((item, index) => {
        return (
          <td key={`td-${index}`} className={item.highlight_column ? 'highlight-column' : ''}>
            {item && item?.cell !== '' && (
              <div className="rich-text" dangerouslySetInnerHTML={{ __html: item.cell || '' }} key={`rich-text-${index}`}></div>
            )}
            {item && item?.asset?.file && <img src={item.asset?.file?.url} alt={item.asset?.alt_text} />}
          </td>
        );
      })}
    </tr>
  );
};

export default TableRow;
